import { Status } from '@app/utils/models/itinerary/status.enum';
import { ParticipationSettings } from 'talkjs/all';

export const TALKJS_CONFIGURATION_SETTINGS = {
  chatWithMemAction: 'schedule-a-call',
  chatWithMemSubtitle: 'Experience Manager',
  chatWithMemType: 'web-mem',
  conversationType: 'member_booking',
  defaultParticipationSettings: { access: 'ReadWrite' } as Partial<ParticipationSettings>,
  itineraryChatType: 'web-itinerary',
  quickReplyAction: 'quick-reply',
  stageTalkjsConversationIdPrefix: 'staging__',
  themeName: 'member-theme',
  tripParticipationSettings: {
    [Status.Abandoned]: { access: 'Read' },
    [Status.Cancelled]: { access: 'Read' },
    [Status.Closed]: { access: 'Read' },
    [Status.Booked]: { access: 'ReadWrite' },
    [Status.Requested]: { access: 'ReadWrite' },
  } as Record<Status, Partial<ParticipationSettings>>,
};
